import React from "react";
import Layout from "../components/layout";
import SEO from "../components/seo";
import OurLuuBeginningCase from "../cases/OurLuuBeginning/ourluubeginning"

const OurLuuBeginning = () => (
    <Layout>
        <SEO title="OurLuuBeginning | Ryan Luu" />
        <OurLuuBeginningCase />
    </Layout>
)

export default OurLuuBeginning